import { SearchPartnerData, SearchType } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';

export function isOnlineConsultationSearch(schedule: SearchPartnerData): boolean {
  return schedule.procedures.some((procedure) => procedure.searchType === SearchType.ONLINE_CONSULTATION);
}
